import { ICONS } from '../shared/icons.generated';

interface IconProps {
  /** e.g. "topic:energy", "goal:socialize", "time:morning", "ui:save" */
  name: string;
  size?: number | string;
  /** Decorative by default; pass a label when the icon is the only content. */
  title?: string;
  className?: string;
}

/**
 * Renders one of the generated inline SVGs. Color comes from CSS
 * `currentColor`, so the same sticky-note artwork works dark-on-pastel inside
 * an event card and pastel-on-dark in the sidebar.
 */
export default function Icon({ name, size = 16, title, className }: IconProps) {
  const icon = ICONS[name];
  if (!icon) return null;
  return (
    <svg
      viewBox={icon.viewBox}
      width={size}
      height={size}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
      style={{ display: 'block', flexShrink: 0, overflow: 'visible' }}
      dangerouslySetInnerHTML={{ __html: title ? `<title>${title}</title>${icon.body}` : icon.body }}
    />
  );
}
